import { FC } from 'react';
import { Link } from '@remix-run/react';
import { useTranslation } from 'react-i18next';
import { ClickAnchor, ClickMenuContainer, IconButton } from '@elements-financial/elements';
import { MessageActionMenuItem } from './MessageActionMenuItem';

export interface MessageActionMenuProps {
  visibilityOptions?: {
    hideOnboardingReminder?: boolean;
    hideQuickCheckIn?: boolean;
    hideSendCalendarSchedulingLink?: boolean;
  };
  clickHandlers: {
    onQuickCheckIn?: () => void;
    onOnboardingReminder?: () => void;
    onSendCalendarSchedulingLink?: () => void;
  };
  routes: {
    quickCheckIn: string;
  };
}

export const MessageActionMenu: FC<MessageActionMenuProps> = ({ clickHandlers, routes, visibilityOptions }) => {
  const { t: tInAppMessaging } = useTranslation('inAppMessaging');
  const { t: tUI } = useTranslation('UI');

  return (
    <ClickAnchor
      offset={[-6, 12]}
      placement="top-start"
      floatingElement={
        <ClickMenuContainer className={'!w-[381px]'}>
          {!visibilityOptions?.hideOnboardingReminder && (
            <MessageActionMenuItem
              icon="rocketLaunch"
              onClick={clickHandlers.onOnboardingReminder}
              title={tInAppMessaging('message-actions-onboarding-reminder-title')}
              text={tInAppMessaging('message-actions-onboarding-reminder-text')}
            />
          )}
          {!visibilityOptions?.hideQuickCheckIn && (
            <Link className="contents" onClick={clickHandlers.onQuickCheckIn} to={routes.quickCheckIn}>
              <MessageActionMenuItem
                icon="messagesCustomFilled"
                onClick={clickHandlers.onQuickCheckIn}
                title={tInAppMessaging('compose-view-templates-menu-quick-check-in-option-title')}
                text={tInAppMessaging('compose-view-templates-menu-quick-check-in-option-description')}
              />
            </Link>
          )}
          {!visibilityOptions?.hideSendCalendarSchedulingLink && (
            <MessageActionMenuItem
              icon="calendarToDay"
              onClick={clickHandlers.onSendCalendarSchedulingLink}
              title={tUI('message-action-menu.item-titles.calendar-scheduling-link')}
              text={tUI('message-action-menu.item-descriptions.calendar-scheduling-link')}
            />
          )}
        </ClickMenuContainer>
      }
    >
      <IconButton type="button" diameter={40} theme="secondary" icon="add" />
    </ClickAnchor>
  );
};
